<template>
  <span class="wrapper">
    <span v-tooltip.bottom="{ content: tooltipContent, contentHtml: true }" :style="{ color: isRejected ? 'red' : 'inherit' }">
      {{ displayValue }}
      <i v-if="isRejected" class="fas fa-info-circle"></i>
    </span>
  </span>
</template>

<script>
  export default {
    computed: {
      isRejected() {
        var rejectStatuses = ['Rejected', 'Declined', 'Exported - Rejected', 'Posted - Rejected', 'Exported - Declined', 'Posted - Declined']
        return rejectStatuses.includes(this.params.value)
      },
      displayValue() {
        return this.params.value.replace(/Rejected/g, 'Declined')
      },
      tooltipContent() {
        return !this.isRejected ? this.params.value : this.getRejectionReason()
      }
    },
    methods: {
      getRejectionReason() {
        return 'Decline Reason: ' + this.params.data.RejectionReason + '<br>Only ' + this.params.data.CreatedByUser + ' can edit this envelope.'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-envelopes/EnvelopeStatus.vue